class LogoCarousel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('[data-logo-track]');
    if (!this.track) return;

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.reduceMotion) return;

    this.ensureFullWidth();
    window.addEventListener('resize', () => this.ensureFullWidth());
  }

  ensureFullWidth() {
    const groups = this.track.querySelectorAll('.logo-carousel__group');
    if (!groups.length) return;

    const containerWidth = this.container.offsetWidth;
    let groupWidth = groups[0].getBoundingClientRect().width;

    // Si les 2 groupes existants ne couvrent pas au moins 2x la largeur visible,
    // on clone le premier groupe (contenu visible) jusqu'à couverture suffisante,
    // pour garantir une boucle sans espace vide sur les grands écrans.
    let totalWidth = groupWidth * groups.length;
    let safety = 0;
    while (totalWidth < containerWidth * 2 && safety < 10) {
      const clone = groups[0].cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
      this.track.appendChild(clone);
      totalWidth += groupWidth;
      safety += 1;
    }
  }
}

document.querySelectorAll('[data-logo-carousel]').forEach((el) => new LogoCarousel(el));